/*
	comment: M端BinaryFile模块
*/
let BinaryFile = function(strData, iDataOffset, iDataLength) {
	let data = strData;
	let dataOffset = iDataOffset || 0;
	let dataLength = 0;
	this.getRawData = function() {
		return data;
	};
	if (typeof strData == 'string') {
		dataLength = iDataLength || data.length;
		this.getByteAt = function(iOffset) {
			return data.charCodeAt(iOffset + dataOffset) & 255;
		};
		this.getBytesAt = function(iOffset, iLength) {
			let aBytes = [];
			for (let i = 0; i < iLength; i++) {
				aBytes[i] = data.charCodeAt(iOffset + i + dataOffset) & 255;
			}
			return aBytes;
		};
	} else if (typeof strData == 'unknown') {
		dataLength = iDataLength || IEBinary_getLength(data);
		this.getByteAt = function(iOffset) {
			return IEBinary_getByteAt(data, iOffset + dataOffset);
		};
		this.getBytesAt = function(iOffset, iLength) {
			return new VBArray(
				IEBinary_getBytesAt(data, iOffset + dataOffset, iLength)
			).toArray();
		};
	}
	this.getLength = function() {
		return dataLength;
	};
	this.getSByteAt = function(iOffset) {
		let iByte = this.getByteAt(iOffset);
		if (iByte > 127) return iByte - 256;
		else return iByte;
	};
	this.getShortAt = function(iOffset, bBigEndian) {
		let iShort = bBigEndian
			? (this.getByteAt(iOffset) << 8) + this.getByteAt(iOffset + 1)
			: (this.getByteAt(iOffset + 1) << 8) + this.getByteAt(iOffset);
		if (iShort < 0) iShort += 65536;
		return iShort;
	};
	this.getSShortAt = function(iOffset, bBigEndian) {
		let iUShort = this.getShortAt(iOffset, bBigEndian);
		if (iUShort > 32767) return iUShort - 65536;
		else return iUShort;
	};
	this.getLongAt = function(iOffset, bBigEndian) {
		let iByte1 = this.getByteAt(iOffset),
			iByte2 = this.getByteAt(iOffset + 1),
			iByte3 = this.getByteAt(iOffset + 2),
			iByte4 = this.getByteAt(iOffset + 3);
		let iLong = bBigEndian
			? (((((iByte1 << 8) + iByte2) << 8) + iByte3) << 8) + iByte4
			: (((((iByte4 << 8) + iByte3) << 8) + iByte2) << 8) + iByte1;
		if (iLong < 0) iLong += 4294967296;
		return iLong;
	};
	this.getSLongAt = function(iOffset, bBigEndian) {
		let iULong = this.getLongAt(iOffset, bBigEndian);
		if (iULong > 2147483647) return iULong - 4294967296;
		else return iULong;
	};
	this.getStringAt = function(iOffset, iLength) {
		let aStr = [];
		let aBytes = this.getBytesAt(iOffset, iLength);
		for (let j = 0; j < iLength; j++) {
			aStr[j] = String.fromCharCode(aBytes[j]);
		}
		return aStr.join('');
	};
	this.getCharAt = function(iOffset) {
		return String.fromCharCode(this.getByteAt(iOffset));
	};
	this.toBase64 = function() {
		return window.btoa(data);
	};
	this.fromBase64 = function(strBase64) {
		data = window.atob(strBase64);
	};
};

export default BinaryFile;



// WEBPACK FOOTER //
// ./src/util/core.BinaryFile.js